import { getPlacesExploreDiagnosticsStore } from './store';

export const getDevPageState = (): string | undefined => {
    return getPlacesExploreDiagnosticsStore().devPageState;
};

export const getDevErrorPageState = (): string | undefined => {
    return getPlacesExploreDiagnosticsStore().devErrorPageState;
};

export const getDevComponentState = (): string | undefined => {
    return getPlacesExploreDiagnosticsStore().devComponentState;
};
